import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Link as EvergreenLink } from "evergreen-ui";

const Link = (props) => <EvergreenLink is={RouterLink} {...props} />;

export default Link;
